import { initialize as user } from '@/models/user/effects'
import { initialize as socket } from '@/models/socket/effects'

const subscriptions = [
  user,
  socket
]

export default function runSubscriptions(store) {
  subscriptions.forEach(sub => {
    sub({
      dispatch: store.dispatch,
      getState: store.getState
    })
  })
}
